<template>
    <general-input
        v-if="shouldShow"
        v-model="bban"
        placeholder="Bankkontonr"
    />
    <div v-else/>
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import GeneralInput from '@/components/GeneralInput.vue'
import {computed} from 'vue'
import {findSubAccountByUuid} from '@/subaccount/subAccount.service'
import {SUPPLIER} from '@/subaccount/types/SubAccount'
import {sanitizeBban} from '@/bank/bank-account.service'

const line = defineModel<TransactionEntryLine>({required: true})

const bban = computed({
    get: () => line.value.bban,
    set: (value: string) => {
        line.value.bban = sanitizeBban(value)
    }
})

const isSupplier = (subAccountUuid: string | undefined) => {
    return subAccountUuid && findSubAccountByUuid(subAccountUuid)?.relationType === SUPPLIER
}

const shouldShow = computed(() => {
    return isSupplier(line.value.creditSubAccount) || isSupplier(line.value.debitSubAccount)
})
</script>

<style scoped>

</style>